module.exports = __webpack_public_path__ + "media/icons/pierwsza-rejestracja-c887ecdb.png";